import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SETTINGS } from '../config/common.settings';
import { BehaviorSubject, Subject } from 'rxjs';
import { EncryptionService } from './encryption.service';

@Injectable({
  providedIn: 'root',
})
export class SettingService {
  brand: any;
  brandChange: any = {};
  onBrandChange: Subject<any> = new BehaviorSubject({});
  onBrandPaymentChange: Subject<any> = new BehaviorSubject({});
  hostnameUrl = '';

  constructor(
    private http: HttpClient,
    private encryption: EncryptionService
  ) {}

  createBrand(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/organization-settings/create`, payload)
        .subscribe({
          next: (response: any) => {
            this.brand = response;
            resolve(this.brand);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  updateBrand(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .put(`${SETTINGS.BASE_API}/organization-settings/update`, payload)
        .subscribe({
          next: (response: any) => {
            this.brand = response;
            resolve(this.brand);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  updateSeasonCategory(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .put(`${SETTINGS.BASE_API}/organization-settings/update-season-category`, payload)
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  findBrand(userId: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .get(`${SETTINGS.BASE_API}/organization-settings/get-one/${userId}`)
        .subscribe({
          next: (response: any) => {
            this.brand = response;
            this.brandChange = response;
            this.onBrandChange.next(this.brandChange);
            resolve(this.brand);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  findBrandPayment(userId: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .get(`${SETTINGS.BASE_API}/organization-settings/get-one/${userId}`)
        .subscribe({
          next: (response: any) => {
            const { isPaid } = response;
            this.brand = response;
            // this.setPInfo(JSON.stringify(isPaid));
            resolve(this.brand);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  addCustomDomain(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${SETTINGS.BASE_API}/organization-settings/add-custom-domain`,
          payload
        )
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  getCustomHostnameInfo(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .get(`${SETTINGS.BASE_API}/organization-settings/custom-hostname-info`)
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  getCustomDomain(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .get(`${SETTINGS.BASE_API}/organization-settings/custom-domain`)
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  removeCustomDomain(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .delete(
          `${SETTINGS.BASE_API}/organization-settings/remvove-custom-domain`
        )
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  saveOpenAiKey(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${SETTINGS.BASE_API}/organization-settings/save-openai-key`,
          payload
        )
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  getOpenAiKey(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .get(`${SETTINGS.BASE_API}/organization-settings/openai-key`)
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  removeOpenAiKey(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .delete(
          `${SETTINGS.BASE_API}/organization-settings/remove-openai-key`
        )
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  getHostnameUrl(): string {
    return this.hostnameUrl;
  }

  setHostnameUrl(url: string): void {
    this.hostnameUrl = url;
  }

  setPInfo(userStr: any): void {
    localStorage.setItem(SETTINGS.PAYMENT, this.encryption.encrypt(userStr));
  }

  getPInfo(): any {
    const userStrEnc: any = localStorage.getItem(SETTINGS.PAYMENT);
    return JSON.parse(this.encryption.decrypt(userStrEnc));
  }
}
